// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1toJC","active":"styles_active__3JTWU","icon":"styles_icon__26JLu","reactIcon":"styles_reactIcon__20Jk5","label":"styles_label__1Hdk5"};